import { render } from "./NettoIcon.vue?vue&type=template&id=6dc6233d&scoped=true"
import script from "./NettoIcon.vue?vue&type=script&lang=js"
export * from "./NettoIcon.vue?vue&type=script&lang=js"

import "./NettoIcon.vue?vue&type=style&index=0&id=6dc6233d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc6233d"]])

export default __exports__